import React from "react";

export function PageHeader({ title, subtitle, actions, testid }) {
  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 md:gap-4 mb-5 md:mb-6" data-testid={testid}>
      <div className="min-w-0">
        <div className="label-caps mb-1">Módulo</div>
        <h1 className="font-display text-2xl sm:text-3xl lg:text-4xl tracking-tight font-light text-[#1C211F]">
          {title}
        </h1>
        {subtitle && <p className="text-[#59645E] text-sm mt-1 md:mt-1.5">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2 flex-wrap md:flex-nowrap">{actions}</div>}
    </div>
  );
}

export function Page({ children }) {
  return <div className="p-4 sm:p-6 lg:p-8 max-w-[1400px] mx-auto">{children}</div>;
}
